var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImgAllCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM15.9951 8.15039C15.4474 7.8377 14.7498 8.02777 14.4365 8.5752L11.3594 13.958L9.46973 11.5537C9.0798 11.0577 8.36145 10.9707 7.86523 11.3604C7.369 11.7502 7.28311 12.4695 7.67285 12.9658L10.6113 16.7061C10.8462 17.0049 11.2146 17.1674 11.5938 17.1396C11.973 17.1118 12.3133 16.8966 12.502 16.5664L16.4209 9.70996C16.7339 9.16196 16.5431 8.46352 15.9951 8.15039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgAllCorrect);
export default __webpack_public_path__ + "static/media/iconImgAllCorrect.be5230056d250e1195a6b228bee93e42.svg";
export { ForwardRef as ReactComponent };